import * as types from "store/types";

import { updateObject, deepClone } from "utils";
import initState from "./initState";
import { VM_CONTROL_ACTIONS, STATIC_URLS } from "consts";

function fetchVMsListStart(state, action) {
  return updateObject(state, {
    loading: action.showReloading,
    serverDownPage: updateObject(state.serverDownPage, {
      show: false,
      status: "",
      msg: ""
    })
  });
}

function fetchVMsListSuccess(state, action) {
  return updateObject(state, {
    vmsList: action.data.vms,
    loading: false
  });
}

function fetchVMsListFailure(state, action) {
  console.log("fetchVMsListFailure");
  return updateObject(state, {
    loading: false,
    serverDownPage: updateObject(state.serverDownPage, {
      show: true,
      status: action.status,
      msg: action.msg
    })
  });
}

function createVMTaskStart(state, action) {
  return updateObject(state, {
    sliderConfig: updateObject(state.sliderConfig, {
      loading: true,
      closeSlider: true
    })
  });
}

function createVMTaskSuccess(state, action) {
  return updateObject(state, {
    sliderConfig: updateObject(state.sliderConfig, {
      loading: false,
      taskCreated: true,
      taskFailed: false
    })
  });
}

function createVMTaskFailure(state, action) {
  return updateObject(state, {
    sliderConfig: updateObject(state.sliderConfig, {
      loading: false,
      taskFailed: true,
      taskCreated: false
    })
  });
}

function fetchTaskStatusListStart(state) {
  return state;
}

function fetchTaskStatusListSuccess(state, action) {
  return updateObject(state, {
    taskIdList: action.data
  });
  // let taskStatus;
  // const updatedTaskIdList = [...state.taskIdList]
  // for (let taskId of state.taskIdList) {
  //   const task = action.data.find(item => item.task_id === taskId);
  //   taskStatus = task.status;
  //   if (task && (task.status === "SUCCESS" || task.status === "FAILURE")) {
  //     updatedTaskIdList = state.taskIdList.filter(id => id !== taskId);
  //   }
  // }
  // return updateObject(state, {
  //   taskIdList: updatedTaskIdList,
  //   taskStatus
  // });
  //return state;
}

function fetchTaskStatusListFailure(state) {
  return state;
}

function createVmTaskIdList(state, action) {
  // Check if action.data is already in taskIdList
  // if (state.taskIdList.includes(action.data)) {
  //   return state;
  // }

  // // If it doesn't exist, update the taskIdList with the new taskId
  // return updateObject(state, {
  //   taskIdList: [...state.taskIdList, action.data]
  // });
  return state;
}

function updateTaskStatus(state, action) {
  return updateObject(state, {
    taskStatus: action.data
  });
}

function controlVMStart(state, action) {
  const vmsList = [...state.vmsList];
  for (const vm of vmsList) {
    if (vm.vm_uuid === action.data.vm_uuid) {
      vm.loading = true;
      break;
    }
  }
  return updateObject(state, {
    vmsList: vmsList
  });
}

function controlVMSuccess(state, action) {
  const vms = [...state.vmsList];
  for (const vm of vms) {
    if (vm.vm_uuid === action.data.vm_uuid) {
      vm.loading = false;
      vm.status = VM_CONTROL_ACTIONS[action.data.action];
      break;
    }
  }
  return updateObject(state, {
    vmsList: vms
  });
}

function controlVMFailure(state, action) {
  const vms = [...state.vmsList];
  for (const vm of vms) {
    if (vm.vm_uuid === action.data.vm_uuid) {
      vm.loading = false;
      break;
    }
  }
  return updateObject(state, {
    vmsList: vms
  });
}

function deleteVMStart(state, action) {
  const vms = [...state.vmsList];
  for (const vm of vms) {
    if (vm.vm_uuid === action.data.vm_uuid) {
      vm.loading = true;
      break;
    }
  }
  return updateObject(state, {
    vmsList: vms
  });
}

function deleteVMSuccess(state, action) {
  let vms = [...state.vmsList];
  vms = vms.filter(val => val.vm_uuid !== action.data.vm_uuid);
  return updateObject(state, {
    vmsList: vms
  });
}

function deleteVMFailure(state, action) {
  const vms = [...state.vmsList];
  for (const vm of vms) {
    if (vm.vm_uuid === action.data.vm_uuid) {
      vm.loading = false;
      break;
    }
  }
  return updateObject(state, {
    vmsList: vms
  });
}

function fetchVIRTRecoveryPointsStart(state, action) {
  return updateObject(state, {
    virtRecoveryPoints: updateObject(state.virtRecoveryPoints, {
      loading: true,
      clients: updateObject(state.virtRecoveryPoints.clients, {
        [action.clientUUID]: { loading: true, recoveryPoints: [] }
      })
    })
  });
}

function fetchVIRTRecoveryPointsSuccess(state, action) {
  return updateObject(state, {
    virtRecoveryPoints: updateObject(state.virtRecoveryPoints, {
      loading: false,
      clients: updateObject(state.virtRecoveryPoints.clients, {
        [action.params.requestConfigParams.clientUUID]: {
          loading: false,
          recoveryPoints: [...action.points]
        }
      })
    })
  });
}

function fetchVIRTRecoveryPointsFailure(state, action) {
  return updateObject(state, {
    virtRecoveryPoints: updateObject(state.virtRecoveryPoints, {
      loading: false,
      recoveryPoints: []
    })
  });
}

function resetSliderConfigs(state) {
  return updateObject(state, {
    sliderConfig: updateObject(state.sliderConfig, {
      loading: false,
      taskFailed: false,
      taskCreated: false,
      closeSlider: false,
      updateFailed: false,
      updateSuccess: false
    }),
    serverDownPage: updateObject(state.serverDownPage, {
      show: false,
      status: "",
      msg: ""
    })
  });
}

function updateVMConfigurationsStart(state, action) {
  return updateObject(state, {
    sliderConfig: updateObject(state.sliderConfig, {
      loading: true,
      updateFailed: false,
      updateSuccess: false,
      closeSlider: false
    })
  });
}

function updateVMConfigurationsSuccess(state, action) {
  let tempSliderConfig = {
    loading: false,
    updateFailed: false,
    updateSuccess: true,
    closeSlider: true
  };

  let tempVMList = [...state.vmsList];

  tempVMList.forEach(vm => {
    if (vm.vm_uuid === action.data.vm_uuid) {
      vm.memory = action.data.memory;
      vm.processors = action.data.processors;
      if (action.data.network) {
        vm.network = { source: "", controller: "" };
        vm.network.source = action.data.network.source;
        vm.network.controller = action.data.network.controller;
      } else {
        vm.network = null;
      }
      vm.video = action.data.video;
      vm.boot_params.enable = action.data.boot_params.enable;
      vm.boot_params.timeout = action.data.boot_params.timeout;
      vm.storage_params.target_bus = action.data.storage_params.target_bus;
    }
  });

  return updateObject(state, {
    sliderConfig: tempSliderConfig,
    vmsList: tempVMList
  });
}

function updateVMConfigurationsFailure(state, action) {
  return updateObject(state, {
    sliderConfig: updateObject(state.sliderConfig, {
      loading: false,
      updateFailed: true,
      updateSuccess: false,
      closeSlider: true
    })
  });
}

export function rebuildVMStart(state, action) {
  const vmsList = [...state.vmsList];
  for (const vm of vmsList) {
    if (vm.vm_uuid === action.vm_uuid) {
      vm.loading = true;
      break;
    }
  }
  return updateObject(state, {
    vmsList: vmsList
  });
}

function rebuildVMSuccess(state, action) {
  const vms = [...state.vmsList];
  for (const vm of vms) {
    if (vm.vm_uuid === action.vm_uuid) {
      vm.loading = false;
      vm.status = VM_CONTROL_ACTIONS["power_on"];
      break;
    }
  }
  return updateObject(state, {
    vmsList: vms
  });
}

function rebuildVMFailure(state, action) {
  const vms = [...state.vmsList];
  for (const vm of vms) {
    if (vm.vm_uuid === action.vm_uuid) {
      vm.loading = false;
      break;
    }
  }
  return updateObject(state, {
    vmsList: vms
  });
}

function fetchVirtUserInfoStart(state, action) {
  return state;
}

function fetchVirtUserInfoSuccess(state, action) {
  let tempInfo = { ...action.data };
  delete tempInfo.username;
  return updateObject(state, {
    userInfo: tempInfo
  });
}

function fetchVirtUserInfoFailure(state, action) {
  return state;
}

function setRpcMachineStatusVi(state, action) {
  return updateObject(state, {
    rpcMachineStatusVi: [...action.data]
  });
}

function setRpcSocketDetailsVi(state, action) {
  return updateObject(state, {
    rpcSocketDetailsVi: { ...state.rpcSocketDetailsVi, ...action.data }
  });
}

function setRPCConsoleAccessInProgress(state, action) {
  //Check if action.data is already in list and update accordingly
  let newObj = { ...state.rpcConsoleAccessinProgressList };
  if (Object.keys(newObj).includes(action.clientUUID))
    delete newObj[action.clientUUID];
  else newObj[action.clientUUID] = action.taskId;
  return updateObject(state, {
    rpcConsoleAccessinProgressList: newObj
  });
}

function setRPCConsoleBootProgress(state, action) {
  //Check if action.data is already in list and update accordingly
  let newArr = [...state.rpcConsoleBootProgressList];
  const index = newArr.indexOf(action.clientUUID);
  if (index > -1) newArr.splice(index, 1);
  else newArr.push(action.clientUUID);
  return updateObject(state, {
    rpcConsoleBootProgressList: newArr
  });
}

function reducer(state = { ...deepClone(initState) }, action) {
  switch (action.type) {
    case types.FETCH_VIRTUAL_MACHINES_LIST_START:
      return fetchVMsListStart(state, action);
    case types.FETCH_VIRTUAL_MACHINES_LIST_SUCCESS:
      return fetchVMsListSuccess(state, action);
    case types.FETCH_VIRTUAL_MACHINES_LIST_FAILURE:
      return fetchVMsListFailure(state, action);
    case types.CREATE_VIRTUAL_MACHINE_TASK_START:
      return createVMTaskStart(state, action);
    case types.CREATE_VIRTUAL_MACHINE_TASK_SUCCESS:
      return createVMTaskSuccess(state, action);
    case types.CREATE_VIRTUAL_MACHINE_TASK_FAILURE:
      return createVMTaskFailure(state, action);
    case types.FETCH_TASK_STATUS_LIST_START:
      return fetchTaskStatusListStart(state, action);
    case types.FETCH_TASK_STATUS_LIST_SUCCESS:
      return fetchTaskStatusListSuccess(state, action);
    case types.FETCH_TASK_STATUS_LIST_FAILURE:
      return fetchTaskStatusListFailure(state);
    case types.CREATE_VM_TASK_ID_LIST:
      return createVmTaskIdList(state, action);
    case types.UPDATE_TASK_STATUS:
      return updateTaskStatus(state, action);
    case types.CONTROL_VM_START:
      return controlVMStart(state, action);
    case types.CONTROL_VM_SUCCESS:
      return controlVMSuccess(state, action);
    case types.CONTROL_VM_FAILURE:
      return controlVMFailure(state, action);
    case types.DELETE_VM_START:
      return deleteVMStart(state, action);
    case types.DELETE_VM_SUCCESS:
      return deleteVMSuccess(state, action);
    case types.DELETE_VM_FAILURE:
      return deleteVMFailure(state, action);
    case types.FETCH_VIRT_RECOVERY_POINTS_START:
      return fetchVIRTRecoveryPointsStart(state, action);
    case types.FETCH_VIRT_RECOVERY_POINTS_SUCCESS:
      return fetchVIRTRecoveryPointsSuccess(state, action);
    case types.FETCH_VIRT_RECOVERY_POINTS_FAILURE:
      return fetchVIRTRecoveryPointsFailure(state, action);
    case types.RESET_SLIDER_CONFIGS:
      return resetSliderConfigs(state, action);
    case types.UPDATE_VM_CONFIGURATIONS_START:
      return updateVMConfigurationsStart(state, action);
    case types.UPDATE_VM_CONFIGURATIONS_SUCCESS:
      return updateVMConfigurationsSuccess(state, action);
    case types.UPDATE_VM_CONFIGURATIONS_FAILURE:
      return updateVMConfigurationsFailure(state, action);
    case types.REBUILDVM_START:
      return rebuildVMStart(state, action);
    case types.REBUILDVM_SUCCESS:
      return rebuildVMSuccess(state, action);
    case types.REBUILDVM_FAILURE:
      return rebuildVMFailure(state, action);
    case types.VIRT_USER_INFO_START:
      return fetchVirtUserInfoStart(state, action);
    case types.VIRT_USER_INFO_SUCCESS:
      return fetchVirtUserInfoSuccess(state, action);
    case types.VIRT_USER_INFO_FAILURE:
      return fetchVirtUserInfoFailure(state, action);
    case types.SET_RPC_MACHINE_STATUS_VI:
      return setRpcMachineStatusVi(state, action);
    case types.SET_RPC_SOCKET_DETAILS_VI:
      return setRpcSocketDetailsVi(state, action);
    case types.RPC_CONSOLE_ACCESS_IN_PROGRESS:
      return setRPCConsoleAccessInProgress(state, action);
    case types.RPC_CONSOLE_BOOT_PROGRESS:
      return setRPCConsoleBootProgress(state, action);
    default:
      return state;
  }
}

export default reducer;
